/** Shared dynamic imports — same chunks React.lazy uses */
export const publicRouteLoaders = {
  "/": () => import("pages/sanatan/Home"),
  "/about": () => import("pages/sanatan/About"),
  "/profile": () => import("pages/sanatan/Profile"),
  "/contact": () => import("pages/sanatan/Contact"),
  "/privacy-policy": () => import("pages/sanatan/PrivacyPolicy"),
  "/terms": () => import("pages/sanatan/TermsCondition"),
  "/child-safety": () => import("pages/sanatan/ChildSafety"),
  "/refund": () => import("pages/sanatan/Refund"),
  "/emergency-help": () => import("pages/sanatan/EmergencyHelp"),
  "/blood-hub": () => import("pages/sanatan/BloodHub"),
  "/events": () => import("pages/sanatan/Event"),
  "/sanatan": () => import("pages/sanatan/Sanatan"),
  "/donation": () => import("pages/sanatan/Donation"),
  "/community": () => import("pages/sanatan/Community"),
  "/login": () => import("pages/sanatan/Login"),
  "/emergency-help-process": () => import("pages/sanatan/EmergencyHelpProcess"),
};

const prefetched = new Set();

export function prefetchRoute(path) {
  if (!path) return;
  const key = path.split("?")[0].replace(/\/$/, "") || "/";
  const loader = publicRouteLoaders[key];
  if (!loader || prefetched.has(key)) return;
  prefetched.add(key);
  loader().catch(() => {
    prefetched.delete(key);
  });
}

/** Prefetch main nav / footer pages after first paint (idle). */
export function preloadPublicRoutes() {
  const priority = [
    "/about",
    "/events",
    "/sanatan",
    "/donation",
    "/contact",
    "/community",
    "/blood-hub",
    "/privacy-policy",
    "/terms",
    "/child-safety",
    "/emergency-help",
    "/login",
  ];

  const run = () => {
    priority.forEach((path, i) => {
      setTimeout(() => prefetchRoute(path), i * 120);
    });
  };

  if (typeof window !== "undefined" && "requestIdleCallback" in window) {
    window.requestIdleCallback(run, { timeout: 2500 });
  } else {
    setTimeout(run, 800);
  }
}
